import { createBuiltinTips } from './builtinTips';
import type { TipImage } from './types';

const images = new Map<string, TipImage>();
let epoch = 0;

for (const tip of createBuiltinTips()) images.set(tip.id, tip);

/**
 * Sampled tips live outside the React store: they are plain byte arrays that the
 * engine turns into textures, and nothing in the UI diffs them. `tipEpoch` is the
 * handle React and the texture cache use to notice new arrivals.
 */
export function registerTipImage(image: TipImage): void {
  images.set(image.id, image);
  epoch += 1;
}

export function getTipImage(id: string | null | undefined): TipImage | null {
  if (!id) return null;
  return images.get(id) ?? null;
}

export function tipImages(): TipImage[] {
  return [...images.values()];
}

export function tipEpoch(): number {
  return epoch;
}
